import { Component, OnInit, Inject  } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { SponsorService } from '../../../services/sponsor.service';
import { Sponsor } from '../../../models/sponsor';
import { AuthService } from '../../../services/auth.service';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-sponsor-dialog',
  templateUrl: './sponsor-dialog.component.html',
  styleUrls: ['./sponsor-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class SponsorDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  public local_title: string;
  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    public _sponsorService: SponsorService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: Sponsor
  ) { }


  ngOnInit() {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
      this.local_title = this.data.name
    } else {
      this.isEdit = false
      this.local_title = "Patrocinador Aplicativo"
    }
    
    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)    
  }

  insert() {
    if (this.entityForm.valid) {
      this._sponsorService.spinner = true;
      let entity: Sponsor = this.createEntity(this.entityForm.value);

      this._sponsorService.insert(entity)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);

          if (this._sponsorService.objectImage) {
            this._sponsorService.uploadImage(this._sponsorService.objectImage, this.data.id)
          }

          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert sponsor error: " + error)
          let msgError: string = this._sponsorService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this._sponsorService.spinner = false
        });
    }

  }

  update() {
    if (this.entityForm.valid) {

      this._sponsorService.spinner = true;
      let entity: Sponsor = this.createEntity(this.entityForm.value);

      this._sponsorService.update(entity)
        .then(() => {

          if (this._sponsorService.objectImage) {
            this._sponsorService.uploadImage(this._sponsorService.objectImage, this.data.id)
          }

          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("sponsor update error: " + JSON.stringify(error))
          let msgError: string = this._sponsorService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this._sponsorService.spinner = false
        });
    }
  }

  createEntity(data: any): Sponsor {
    let entity = new Sponsor();
    entity.id = data.id;
    entity.name = data.name;
    entity.url = data.url;
    entity.image = data.image;
    return entity;
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.url.setValue(data.url ? data.url : "");
    form.controls.image.setValue(data.image ? data.image : "");

    this._sponsorService.storedImage = data.image ? data.image : "assets/images/geral/sponsor_logo_default.jpg"
  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      url: new FormControl(''),
      image: new FormControl(''),
    });
    return form
  }


}
